import { render } from "./SamplingAnalysisList.vue?vue&type=template&id=c5a81a9e"
import script from "./SamplingAnalysisList.vue?vue&type=script&lang=js"
export * from "./SamplingAnalysisList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__